import Skeleton from '@/components/common/Skeleton';

const TitleSkeleton: React.FC<any> = ({ viewRef }) => {
  return (
    <div className="mx-0 my-2.5 px-5 py-0" ref={viewRef}>
      <Skeleton.Paragraph rows={1} style={{ height: 24 }} />
    </div>
  );
};

export default TitleSkeleton;
